<template>
  <v-card
    id="financial"
    :border="$role == 'specialist'"
    class="mb-4"
    flat
    tile
  >
    <v-card-title class="tab-title d-flex">
      <v-btn
        v-if="showProviderProfileNavBtn"
        @click="emit('toggleProviderProfileNav')"
        :aria-label="$bct('Toggle provider profile navigation')"
        data-cy="provider_profile_nav_icon"
        icon="menu_open"
        variant="text"
      />
      <h2 class="v-card-title py-0 px-0 d-flex align-center">
        {{ $bct('Financial programs') }}
      </h2>
    </v-card-title>
    <v-divider />
    <v-card-text class="my-4">
      <v-row>
        <LabeledSelect
          v-model="provider.payment_methods_accepted"
          id="manager_select_payment_types"
          :message="getLabelByProperty('payment_methods_accepted', 'Payment methods accepted')"
          :schema-id="provider.schema_id"
          data-cy="payment_methods_accepted"
          field="payment_methods_accepted"
          global
          tracked
        />
        <LabeledSelect
          v-model="provider.payment_subsidies_accepted"
          id="manager_select_financial_options"
          :message="getLabelByProperty('payment_subsidies_accepted', 'Subisides accepted')"
          :schema-id="provider.schema_id"
          data-cy="manager_select_financial_options"
          field="payment_subsidies_accepted"
          global
          tracked
        />
        <LabeledSelect
          v-model="provider.payment_other_programs"
          id="manager_select_head_start_options"
          :locked="lockHeadStart"
          :message="getLabelByProperty('payment_other_programs', 'Other assistance programs')"
          :schema-id="provider.schema_id"
          data-cy="manager_select_head_start_options"
          field="payment_other_programs"
          global
          tracked
        />
        <LabeledTextarea
          v-model="provider.payment_other_description"
          id="manager_other_financial_options"
          :message="getLabelByProperty('payment_other_description', 'Additional payment options')"
          :schema-id="provider.schema_id"
          data-cy="manager_other_financial_options"
          field="payment_other_description"
          global
          tracked
        />
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { useStore } from 'vuex';

import LabeledSelect from '@/shared/components/form/LabeledSelect.vue';
import LabeledTextarea from '@/shared/components/form/LabeledTextarea.vue';
import useSchematizedField from '@/shared/composables/useSchematizedField';

const store = useStore();
const $bct = inject('translator');

const props = defineProps({
  provider: {
    type: Object,
    default: null,
  },
  showProviderProfileNavBtn: {
    type: Boolean,
    default: null,
  },
});

const { getLabelByProperty } = useSchematizedField(
  ref(null),
  ref(null),
  ref(null),
  ref(null),
  computed(() => props.provider?.schema_id),
);

const emit = defineEmits(['progress', 'toggleProviderProfileNav']);

const lockHeadStart = computed(() => {
  return (
    store.state.role === 'manager' && store.state.pages.Provider.features.enable_headstart_lock
  );
});

const progress = computed(() => {
  const dataProvided = [
    props.provider.payment_methods_accepted || [],
    props.provider.payment_subsidies_accepted || [],
    props.provider.payment_other_programs || [],
    props.provider.payment_other_description || '',
  ];

  return dataProvided.some((element) => element.length > 0) ? 100 : 0;
});

watch(
  () => progress.value,
  (newVal) => {
    emit('progress', newVal);
  },
  { immediate: true },
);
</script>
